import moment from 'moment';
import { currentWindowSize, userAgent } from 'ecs-react-components/dist/index.es';

const groupBy = require('lodash/groupBy');
const orderBy = require('lodash/orderBy');
const mapValues = require('lodash/mapValues');

export const nest = (seq, keys, sortKeys, sortDirs) => {
  if (!keys.length) {
    return seq;
  }
  const first = keys[0];
  const rest = keys.slice(1);
  const sorted = orderBy(seq, sortKeys, sortDirs);
  return mapValues(groupBy(sorted, first), (value) => nest(value, rest, sortKeys, sortDirs));
};

export const mapArticles = (articles, clickHandler, dispatch, displayType, selectedArticleId, language) => {
  if (!articles || articles.length < 1) {
    return {};
  }
  const mappedArticles = articles.map((article) => {
    const mapped = article;
    moment.locale(language);
    if (!mapped.rawDate) {
      mapped.rawDate = article.assignedDate; // raw date from api retained for locale translations
    }
    mapped.assignedDate = moment(mapped.rawDate).format('ll');

    // Adding look and feel related attributes
    mapped.understated = !!article.isArchived;
    mapped.isNew = !article.wasReadByPatient && !article.isArchived;
    mapped.selected = article.articleId === selectedArticleId;
    mapped.clickHandler = () => {
      let newWin = window;
      let inline = false;
      if (currentWindowSize() === 'medium' || currentWindowSize() === 'large') {
        if (userAgent('iPad') || displayType === 'NewTab') {
          newWin = window.open('about:blank', '_blank');
        } else {
          inline = true;
        }
      }
      dispatch(clickHandler(article.articleId, newWin, inline));
    };
    return mapped;
  });
  return nest(
    mappedArticles,
    ['assignedDate', 'categoryName'],
    [(article) => moment(new Date(article.rawDate)), 'categorySortOrder', 'categoryName'],
    ['desc', 'asc', 'asc']
  );
};

